/**
 * /settings/admin-api — network-level admin API console (FS-225 / DASH).
 *
 * Flat-file TanStack Router route: dots map to slashes, so
 * `settings.admin-api.tsx` mounts at `/settings/admin-api`. Delegates all
 * rendering to `AdminApiPage` so the route file stays a thin wiring shim.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdminApiPage } from "@/features/admin-api/AdminApiPage";

// ---------------------------------------------------------------------------
// No search params — the page loads its own tenant context from the
// api-client's tenant header and there are no deep-link selections yet.
// ---------------------------------------------------------------------------

export const settingsAdminApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/settings/admin-api",
	component: AdminApiPage,
});

export default settingsAdminApiRoute;

// Re-export for convenience so the shared router wire-up can import either
// the route or the page component from a single module path.
export { AdminApiPage } from "@/features/admin-api/AdminApiPage";
